import axiosInstance from 'api/axiosInstance';

export const createIncidentPatrolSchedule = async (
	date: Date | null,
	contactID: number,
	schedule: any,
): Promise<number> => {
	let url =
		'/Project/WebService/CANDispatch.asmx/CreateIncidentPatrolSchedule';
	if (process.env.NODE_ENV === 'production') {
		url = '/Portal' + url;
	}
	const response = await axiosInstance.post(url, {
		payload: {
			ReadProps: {
				Date: date,
				ContactId: contactID,
			},
			Schedule: [schedule],
		},
	});
	const returnedScheduleAssignmentID = response?.data?.Payload?.Id;
	return returnedScheduleAssignmentID;
};
